// Faq.jsx
import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MdKeyboardArrowDown } from "react-icons/md";
import "./CheckInLanding.css";

const faqs = [
    {
        q: "What happens if I forget to check in?",
        a: "We send a calm, clear alert to your designated contacts with the context you set up — including your last known plans.",
    },
    {
        q: "Who gets alerted, and when?",
        a: "Only the contacts you choose. Alerts trigger at the exact moment your check-in window closes — not a second sooner.",
    },
    {
        q: "Can I extend a check-in time?",
        a: "Yes. Push your timer forward in seconds, from anywhere — lock screen, watch, or app.",
    },
    {
        q: "Does Keep in Touch track my location?",
        a: "Never. We only know whether you tapped 'safe' before your timer ran out.",
    },
    {
        q: "Is this only for emergencies?",
        a: "No. Most users check in for everyday calm — late nights out, long drives, or quiet weekends.",
    },
];

const Faq = () => {
    const [openFaq, setOpenFaq] = useState(0);

    const toggleFaq = (index) => {
        setOpenFaq(openFaq === index ? null : index);
    };

    return (
        <section className="faq-modern-section" id="faq">
            <Container>
                <Row className="g-5 align-items-start">

                    {/* Left Side */}
                    <Col lg={4}>
                        <div className="faq-left">
                            <span className="faq-mini-title">— FAQ</span>

                            <h2 className="faq-main-title">
                                Questions, <span>answered.</span>
                            </h2>

                            <p className="faq-left-desc">
                                Still curious? Reach us at{" "}
                                <a href="#">hello@keepintouch.app</a>
                            </p>
                        </div>
                    </Col>

                    {/* Right Side */}
                    <Col lg={{ span: 7, offset: 1 }}>
                        <div className="faq-list">
                            {faqs.map((item, index) => {
                                const active = openFaq === index;

                                return (
                                    <div
                                        key={index}
                                        className={`faq-box ${active ? "active" : ""}`}
                                    >
                                        <button
                                            className="faq-question"
                                            onClick={() => toggleFaq(index)}
                                        >
                                            <span>{item.q}</span>

                                            <MdKeyboardArrowDown
                                                className={`faq-icon ${
                                                    active ? "rotate" : ""
                                                }`}
                                            />
                                        </button>

                                        <div
                                            className={`faq-answer ${
                                                active ? "show" : ""
                                            }`}
                                        >
                                            <p>{item.a}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </Col>

                </Row>
            </Container>
        </section>
    );
};

export default Faq;